export const RESPONSE_CONTENTS_OK = [
  {
    id: 'NEW1',
  },
  {
    id: 'NEW2',
  },
];

export const RESPONSE_SINGLE_CONTENT = [
  {
    id: 'NEW1',
  },
];

export const RESPONSE_DELETE_OK = {
  result: 'ok',
};

export const RESPONSE_PUBLISH_OK = {
  result: 'ok',
};

export const MOCK_CONTENTS_STATUS = {
  published: 0,
  ready: 0,
  total: 0,
  unpublished: 0,
};
